import React, {useRef, useState } from 'react';

import ButtonSelect from '../ui/ButtonSelect';

import './index.css';
import IconSelect from '../icons/IconSelect';

const BaseSelect = (props) => {
  const selectRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSelect = (e) => {
    setIsOpen(!isOpen);
    document.body.addEventListener('click', closeSelect);
    e.stopPropagation();
  };

  const closeSelect = (e) => {
    if (e.type === 'blur') return setIsOpen(false);
    if (!selectRef.current.contains(e.target)) {
      setIsOpen(false);
      document.body.removeEventListener('click', closeSelect);
    }
  }

  const choseOption = option => {
    props.selectOption(props.selectOptions.prop, option);
    setIsOpen(false);
  }

  return (
    <div className={`base-select ${props.wrapperClassName}`} ref={selectRef}>
      {props.format === 'button' &&
        <ButtonSelect
          name={props.name}
          onClick={props.readOnly ? null : toggleSelect}
        />
      }
      {props.format === 'select' &&
        <>
          <input
            className={`base-select__input ${props.inputClassName}`}
            readOnly
            value={props.value}
            onFocus={props.readOnly ? null : toggleSelect}
            onBlur={props.readOnly ? null : closeSelect}

              />
          {
            !props.readOnly &&
            <IconSelect className="base-select__icon"/>
          }
        </>
      }
      {
        isOpen &&
        <div className="base-select__data">
          <ul className="base-select__list" >
            {
              props.selectOptions.options.map(option => (
                <li
                  className="base-select__item"
                  onMouseDown={() => choseOption(option)}
                  key={option}
                >{option}</li>
              ))
            }
          </ul>
        </div>
      }
    </div>
  );
}

export default BaseSelect;
